import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

import ValidatorSubmittedSeePage from "./ValidatorSubmittedSee"

import { GET_VALIDATOR_SUBMITTED_CI, ACCEPT_VALIDATOR_CI, EDIT_VALIDATOR_CI, REJECT_VALIDATOR_CI } from "../../AppConstant";

function ValidatorSubmitted({ userDetails, setParentLoading }) {

    const [isValidated, setIsValidated] = useState(false); 
    const [submitted, setSubmitted] = useState([]);
    const [commentName, setCommentName] = useState("");
    const [selectedItem, setSelectedItem] = useState("");

    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSeeModal, setShowSeeModal] = useState(false);

    const getSubmitted = async () => {

        try {
            setParentLoading(true);
            const emailid = localStorage.getItem("emailid");

            const res = await axios.get(GET_VALIDATOR_SUBMITTED_CI, {
                params: { "validatoremail": emailid }
            });
            setSubmitted(res.data);
            console.log("API response:", res.data);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        } catch (err) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.error(err);
        }
    };

    const handleOpenDeleteModal = async (id) => {
        setParentLoading(true);
        setSelectedItem(id);
        setShowDeleteModal(true);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleCloseDeleteModal = () => {
        setParentLoading(true);
        setCommentName("");
        setShowDeleteModal(false);
        setSelectedItem("");
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleOpenEditModal = async (id) => {
        setParentLoading(true);
        setSelectedItem(id);
        setShowEditModal(true);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleCloseEditModal = () => {
        setParentLoading(true);
        setCommentName("");
        setShowEditModal(false);
        setSelectedItem("");
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleOpenSeeModal = async (item) => {
        localStorage.setItem('swipexid', item.id)
        localStorage.setItem('swipexempid', item.empid)

        if(item.isvalidatorapproved == "approved" || item.isvalidatorapproved == "rejected" || item.status == "F" || item.status == "A" || item.status == "U"){
            setIsValidated(true);
        }else{
            setIsValidated(false);
        }

        setParentLoading(true);
        setShowSeeModal(true);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleCloseSeeModal = () => {
        setParentLoading(true);
        setShowSeeModal(false);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const ValidatorAccept = async (id) => {
        try {
            setParentLoading(true);
            await axios.post(ACCEPT_VALIDATOR_CI, {
                swipexid: id
            });

            handleCloseSeeModal();

            getSubmitted();
            setTimeout(() => {
                setParentLoading(false);
            }, 500);


        } catch (error) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.log(error)
        }

    }

    const ValidatorReject = async (id, comment) => {
        try {
            setParentLoading(true);
            await axios.post(REJECT_VALIDATOR_CI, {
                swipexid: id,
                comments: comment
            });

            handleCloseSeeModal();

            getSubmitted();
            setCommentName("");

            setShowDeleteModal(false);
            setSelectedItem("");

            setTimeout(() => {
                setParentLoading(false);
            }, 500);

        } catch (error) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.log(error)
        }

    }

    const ValidatorEdit = async (id, comment) => {
        try {
            setParentLoading(true);
            await axios.post(EDIT_VALIDATOR_CI, {
                swipexid: id,
                comments: comment
            });

            handleCloseSeeModal();

            getSubmitted();
            setCommentName("");

            setShowEditModal(false);
            setSelectedItem("");

            setTimeout(() => {
                setParentLoading(false);
            }, 500);

        } catch (error) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.log(error)
        }

    }

    useEffect(() => {
        getSubmitted();
    }, []);

   const generateStage = (item) => {

        const normalize = (val) =>
            val === null || val === undefined || val === ""
                ? null
                : val.toString().trim().toLowerCase();

        const VA = normalize(item.isvalidatorapproved);
        const AA = normalize(item.isapproverapproved);
        const status = item.status;


        if (status === "U") {
            // return "Update request have been given, please update it, check comments for more details"
            return "";
        }

        if (!VA) {
            // return "Pending with Reporting Manager";
            return "Validator";
        }

        if (VA === "rejected") {
            // return "Rejected (Reporting Manager)";
            return "Validator";
        }

        if (VA === "approved" && !AA) {
            // return "Pending with Approver";
            return "Approver";
        }

        if (AA === "rejected") {
            // return "Rejected (Approver)";
            return "Approver";
        }

        if (status === "A") {
            // return "ACCEPTED";
            return "";
        }

        return "Unknown";
    };

     const [searchTerm, setSearchTerm] = useState("");
        
            const filteredRecords = submitted.filter((item) => {
            const searchableText = [
                ...Object.values(item),
                generateStage(item)
            ]
                .join(" ")
                .toLowerCase();
        
            return searchableText.includes(searchTerm.toLowerCase());
        });

        const [expandedComment, setExpandedComment] = useState(null);
                
                const handleSeeMore = (index) => {
                  setExpandedComment(expandedComment === index ? null : index);
                };

    return (
        <div>

 <div className="input-group mb-3" style={{ width: "500px" }}>
    <span className="input-group-text">
        <i className="bi bi-search"></i>
    </span>

    <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
    />
</div>

             <table className="mt-1 fw-bold" style={{fontSize:"small"}}>
                <thead className="bg-success-subtle" style={{ width:"100%", color:"green" }} >
                    <tr style={{width:"3%"}}>
                        <th style={{width:"3%"}}>S.No</th>
                        <th style={{width:"10%"}}>SWIPEX ID</th>
                        <th style={{width:"7%"}}>EMPLOYEE ID</th>
                        <th style={{width:"15%"}}>EMPLOYEE NAME</th>
                        <th style={{width:"15%"}}>TITLE </th>
                        {/* <th style={{width:"10%"}}>STATUS & STAGE</th> */}
                        <th  style={{width:"6%"}}>VALIDATOR</th>
                        <th  style={{width:"6%"}}>APPROVER</th>
                        <th style={{width:"13%"}}>COMMENTS</th>
                        <th style={{width:"9%"}}>ACTION</th>
                        <th style={{width:"8%"}}>CREATED AT</th>
                        <th style={{width:"8%"}}>LAST UPDATE</th>
                    </tr>
                </thead>

                <tbody className="text-white" style={{ fontSize: "small" }}>
                    {filteredRecords.length > 0 ? (
                        filteredRecords.map((sub, index) => (
                            <tr key={sub.id}>

                                <td>{index + 1}</td>
                                <td>{sub.id}</td>
                                <td>{sub.empid}</td>
                                <td>{sub.empname}</td>
                                <td>{sub.title}</td>

                                {/* <td >
                                    <span
                                        className={`status-text ${sub.status === "T"
                                            ? "status-pending"
                                            : sub.status === "F"
                                                ? "status-rejected"
                                                : sub.status === "U"
                                                    ? "status-update"
                                                    : sub.status === "A"
                                                        ? "status-accepted"
                                                        : "status-unknown"
                                            }`}
                                    >
                                        {sub.status === "T"
                                            ? "Pending"
                                            : sub.status === "F"
                                                ? "Rejected"
                                                : sub.status === "U"
                                                    ? "Update"
                                                    : sub.status === "A"
                                                        ? "Accepted"
                                                        : "Unknown"}
                                    </span>
                                    <br></br>
                                    {generateStage(sub)}
                                </td> */}


                                  <td> <span
                                        className={`status-text ${sub.status === "U"
                                                    ? "status-update"
                                                      :sub.isvalidatorapproved == "approved"
                                                      ? "status-accepted"
                                                      :sub.isvalidatorapproved == "rejected"
                                                      ? "status-rejected"
                                                        : "status-unknown"
                                            }`}
                                    >
                                        {sub.status === "U"
                                            ? "Update"
                                            : sub.isvalidatorapproved == "approved"
                                                ? "Approved"
                                                : sub.isvalidatorapproved == "rejected"
                                                ? "Rejected"
                                                        : "Pending"}
                                    </span></td>

                                      <td> <span
                                        className={`status-text ${sub.status === "U"
                                                    ? "status-update"
                                                    :sub.isvalidatorapproved == "rejected"
                                                      ? "status-rejected"
                                                      :sub.isapproverapproved == "approved"
                                                      ? "status-accepted"
                                                      :sub.isapproverapproved == "rejected"
                                                      ? "status-rejected"
                                                        : "status-unknown"
                                            }`}
                                    >
                                        {sub.status === "U"
                                            ? "Update"
                                            : sub.isvalidatorapproved == "rejected"
                                                ? "Rejected"
                                            : sub.isapproverapproved == "approved"
                                                ? "Approved"
                                                : sub.isapproverapproved == "rejected"
                                                ? "Rejected"
                                                        : "Pending"}
                                    </span></td>



                                 <td title={sub.comments}>
  {expandedComment === index || sub.comments?.length <= 40 ? (
    sub.comments
  ) : (
    <>
      {sub.comments.substring(0, 40)}...
      <i
        onClick={() => handleSeeMore(index)}
        style={{
          color: "black",
          cursor: "pointer",
          marginLeft: "5px",
        }}
      >
        See more
      </i>
    </>
  )}
</td>

                                <td>
                                    <div className="d-flex justify-content-center fw-bold" style={{ fontSize: "18px" }}>
                                            <i class="bi bi-eye-fill" style={{ color: "blue", cursor: "pointer" }} title="See" onClick={() => handleOpenSeeModal(sub)}></i>
                                    </div>

                                    {sub.isupdate ? (<span style={{ color: "blue", fontWeight: "bold" }}>
                                        Update Request has been sent
                                    </span>
                                    ) : sub.isvalidatorapproved === "approved" ? (
                                        <span style={{ color: "greenyellow", fontWeight: "bold" }}>
                                            APPROVED
                                        </span>
                                    ) : sub.isvalidatorapproved === "rejected" ? (
                                        <span style={{ color: "orangered", fontWeight: "bold" }}>
                                            REJECTED
                                        </span>
                                    ):null}
                                </td>

                                <td>
                                    {new Date(sub.createdat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td>

                                <td>
                                    {new Date(sub.lastupdatedat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td>

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="11" style={{ textAlign: "center" }}>
                                 No records available...!
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>


            {/* DELETE */}

            <Modal
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                backdrop="static"
                keyboard={false}
                style={{ backgroundColor: "rgba(49, 48, 48, 0.9)" }}
            >
                <Modal.Header style={{ justifyContent: "center" }}>
                    <Modal.Title style={{ color: "red", fontWeight: "bold", textAlign: "center" }}>REJECT</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="form-group">
                        <label for="name">Comments</label>
                        <textarea rows="3" placeholder="Tell them why it was rejected..." className="form-control" name="comments" id="commentsid" maxLength={100} value={commentName} onChange={(e) => setCommentName(e.target.value)} />
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        Close
                    </Button>
                    <Button variant="success" onClick={() =>
                        ValidatorReject(
                            selectedItem,
                            commentName
                        )
                    }>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* FEEDBACK */}

            <Modal
                show={showEditModal}
                onHide={handleCloseEditModal}
                backdrop="static"
                keyboard={false}
                style={{ backgroundColor: "rgba(49, 48, 48, 0.9)" }}
            >
                <Modal.Header style={{ justifyContent: "center" }}>
                    <Modal.Title style={{ color: "orange", fontWeight: "bold", textAlign: "center" }}> FEEDBACK</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="form-group">
                        <label for="name">Comments</label>
                        <textarea rows="3" placeholder="Tell them what to edit..." className="form-control" name="comments" id="commentsid" maxLength={500} value={commentName} onChange={(e) => setCommentName(e.target.value)} />
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditModal}>
                        Close
                    </Button>
                    <Button variant="success" onClick={() =>
                        ValidatorEdit(
                            selectedItem,
                            commentName
                        )
                    }>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showSeeModal}
                onHide={handleCloseSeeModal}
                backdrop="static"
                keyboard={false}
                fullscreen
            >
                <ValidatorSubmittedSeePage userDetails={userDetails} isValidated={isValidated} handleCloseSeeModal={handleCloseSeeModal} ValidatorAccept={ValidatorAccept} handleOpenEditModal={handleOpenEditModal} handleOpenDeleteModal={handleOpenDeleteModal} setParentLoading={setParentLoading} />
            </Modal>

        </div>
    );
}

export default ValidatorSubmitted;